import React, {useState, useEffect} from 'react';


const Media = (props) => {
    const [frame, setFrame] = useState('');

    const init = () => {
        const url = new URL(props.mediaData.url);
        let parametr;
        if(props.mediaData.type === "youtubeVideo"){
            parametr = url.searchParams.get('v');
            if(!parametr)
                parametr = props.mediaData.url.split('/')[3];
            setFrame(<iframe id="ytplayer" type="text/html"
                            src={"https://www.youtube.com/embed/"+parametr}
                            frameBorder="0"
                            style={{width: "100%", height: "100%", aspectRatio: "16/9"}}
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen/>);
        } else if(props.mediaData.type === "vimeoVideo") {
            parametr = props.mediaData.url.split('/')[3];
            setFrame(<iframe src={"https://player.vimeo.com/video/"+parametr}
            style={{width: "100%", height: "100%", aspectRatio: "16/9"}} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe>)
        }else{
            parametr = url.searchParams.get('m');
            setFrame(<iframe src={"https://my.matterport.com/show/?m="+parametr} frameBorder="0"
                        allowFullScreen allow="xr-spatial-tracking"
                        style={{width: "100%", height: "100%", aspectRatio: "16/9"}}></iframe>);
        }
    }

    useEffect(()=>{
        init();
    }, [props.index]);

    useEffect(()=>{
        init();
    }, [])

    return (
        <div className="media_wrap">
            <div className="address_slide_wrap">
                <div className="address_slide">{props.address}</div>
            </div>
            <div className="media" style={{width: "100%", height: "100%"}}>
                {frame}
            </div>
        </div>
    )
}
// https://my.matterport.com/show/?m=roWLLMMmPL8
export default Media;